import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import jm, { errorMessage } from '../api';
import CandidateTable, { NameCell, RowActions, StatusBadge } from '../common/CandidateTable';

/**
 * Search across everyone who has reached the interview stage, by key skill,
 * name, email or mobile — the old app's Search tab.
 */
const Search = () => {
  const [term, setTerm] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (term.trim() === '') {
      setRows([]);
      return undefined;
    }

    const timer = setTimeout(() => {
      setLoading(true);
      jm.search(term.trim())
        .then((data) => setRows(Array.isArray(data) ? data : []))
        .catch((error) => toast.error(errorMessage(error, 'Search failed')))
        .finally(() => setLoading(false));
    }, 400);

    return () => clearTimeout(timer);
  }, [term]);

  const columns = [
    { key: 'action', label: 'Action', search: false, sortable: false, render: (row) => <RowActions row={row} /> },
    { key: 'first_name', label: 'Candidate Name', render: (row) => <NameCell row={row} /> },
    { key: 'job_title', label: 'Job Title' },
    { key: 'email', label: 'Email' },
    {
      key: 'key_status',
      label: 'Status',
      search: false,
      render: (row) => (Number(row.key_status) === 1
        ? <StatusBadge label="Joined" tone="success" />
        : <StatusBadge label="Pending" />),
    },
    { key: 'key_skills', label: 'Key Skills' },
    { key: 'contact_no', label: 'Mobile' },
  ];

  return (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <label>Search by key skill, name, email or mobile</label>
          <input
            className="form-control"
            placeholder="e.g. Tamil, 9442456992, joy@…"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
          />
        </div>
      </div>

      <CandidateTable
        title="Search Results"
        rows={rows}
        columns={columns}
        loading={loading}
        emptyText={term.trim() ? 'No candidates matched.' : 'Type something to search.'}
        exportName="candidate_search"
      />
    </>
  );
};

export default Search;
